import { useQuery, gql, type QueryResult } from '@apollo/react-hooks';
import { getManufacturer } from '#/graphql/queries';
import type { GetManufacturerQuery } from '#/graphql/types';

export const GET_MANUFACTURER = gql(getManufacturer);

const useManufacturerQuery = (id?: string) => {
  const query: QueryResult<GetManufacturerQuery> = useQuery(GET_MANUFACTURER, {
    variables: { id },
    fetchPolicy: 'cache-and-network',
  });

  return query;
};

export default useManufacturerQuery;
